import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export const hex2rgba = function (hex) {
  let alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const _hex$match$map = hex.match(/\w\w/g).map(x => parseInt(x, 16)),
    _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
    r = _hex$match$map2[0],
    g = _hex$match$map2[1],
    b = _hex$match$map2[2];
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};
export const getStringHash = str => {
  let hash = 0;
  let chr;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
export const getColorFromHashAndPalette = (hash, pallette) => {
  if (!hash || !pallette || !pallette.length) return null;
  const paletteCount = pallette.length;
  const colorIndex = Math.abs(hash) % paletteCount;
  return pallette[colorIndex];
};